export default __webpack_public_path__ + "static/media/full_logo.0011b5be.svg";